import { IconButton } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import {
	QuantityFieldButtons,
	QuantityFieldInput,
	QuantityFieldWrapper
} from "features/MarketingMaterials/pages/Checkout/components/CartItem/QuantityField.styles.ts";

export interface QuantityFieldProps {
	quantity: number;
	onQuantityChanged: (quantity: number, isOverride: boolean) => void;
}

export const QuantityField = ({ quantity, onQuantityChanged }: QuantityFieldProps) => {
	const [quantityInput, setQuantityInput] = useState(String(quantity));

	useEffect(() => {
		setQuantityInput(String(quantity));
	}, [quantity]);

	const changeQuantity = (qty: number) => {
		onQuantityChanged(qty, false);
	};

	const handleQuantityInputChange = (value: string) => {
		setQuantityInput(value.replace(/\D/g, "").slice(0, 3));
	};

	const submitQuantityOverride = () => {
		const nextQuantity = Number.parseInt(quantityInput, 10);
		const sanitizedQuantity = Number.isNaN(nextQuantity) ? 0 : nextQuantity;

		setQuantityInput(String(sanitizedQuantity));
		onQuantityChanged(sanitizedQuantity, true);
	};

	return (
		<QuantityFieldWrapper>
			<p>Qty</p>
			<QuantityFieldButtons>
				<IconButton onClick={() => changeQuantity(-1)}>
					<RemoveIcon />
				</IconButton>
				<QuantityFieldInput
					value={quantityInput}
					size="small"
					onChange={(event) => handleQuantityInputChange(event.target.value)}
					onBlur={submitQuantityOverride}
					onKeyDown={(event) => {
						if (event.key === "Enter") {
							event.preventDefault();
							submitQuantityOverride();
						}
					}}
					slotProps={{
						input: {
							inputProps: {
								inputMode: "numeric",
								pattern: "[0-9]*",
								maxLength: 3,
								min: 0
							}
						}
					}}
				/>
				<IconButton onClick={() => changeQuantity(1)}>
					<AddIcon />
				</IconButton>
			</QuantityFieldButtons>
		</QuantityFieldWrapper>
	);
};
